
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteExchange, exchangeSearch
} from "./ExchangeClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeExchange} from "./exchangeSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import ExchangeDrawer from "./ExchangeDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import Button from "@mui/material/Button";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import ExchangeSearch from "./ExchangeSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {UsageGridColumns} from "../Usage/UsageGridColumns";
import {changeUsage} from "../Usage/usageSlice";
import {ExchangeGridColumns} from "./ExchangeGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import ExchangeInfoDialogue from "./Info/ExchangeInfoDialogue";

// main function
export default function ExchangeGrid() {

    // ****************** BEGIN STATES ****************************

    const [exchanges, setExchanges] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [exchangeInfoOpen, setExchangeInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorExchangeId = useSelector((state) => state.exchangeSlc.value.id);
    // const selectorExchangeMcode = useSelector((state) => state.exchangeSlc.value.mcode);
    // const selectorExchangeName = useSelector((state) => state.exchangeSlc.value.name);
    // const selectorExchangeDescription = useSelector((state) => state.exchangeSlc.value.description);
    // const selectorExchangeCategory = useSelector((state) => state.exchangeSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.exchangeSlc.value.exchangeDrawerState);
    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorIdFrom = useSelector((state) => state.exchangeSearchSlc.value.idFrom);
    const selectorIdTo = useSelector((state) => state.exchangeSearchSlc.value.idTo);
    const selectorExternalIdFrom = useSelector((state) => state.exchangeSearchSlc.value.externalIdFrom);
    const selectorExternalIdTo = useSelector((state) => state.exchangeSearchSlc.value.externalIdTo);
    const selectorRateDateFrom = useSelector((state) => state.exchangeSearchSlc.value.rateDateFrom);
    const selectorRateDateTo = useSelector((state) => state.exchangeSearchSlc.value.rateDateTo);
    const selectorCurrencyFrom = useSelector((state) => state.exchangeSearchSlc.value.currencyFrom);
    const selectorCurrencyTo = useSelector((state) => state.exchangeSearchSlc.value.currencyTo);
    const selectorRate = useSelector((state) => state.exchangeSearchSlc.value.rate);
    const selectorSource = useSelector((state) => state.exchangeSearchSlc.value.source);
    const selectorEffectiveDate = useSelector((state) => state.exchangeSearchSlc.value.effectiveDate);
    const selectorExpiredOn = useSelector((state) => state.exchangeSearchSlc.value.expiredOn);
    const selectorIsActive = useSelector((state) => state.exchangeSearchSlc.value.isActive);


    const selectedId = useSelector((state) => state.exchangeSlc.value.id);

    const dispatchData = useDispatch();

    const selectorExchangeGridRefresh = useSelector((state) => state.exchangeSlc.value.exchangeGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchExchanges = () =>{
    //     if(
    //         selectorIdFrom !== null ||
    //         selectorIdTo !== null ||
    //         selectorExternalIdFrom !== null ||
    //         selectorExternalIdTo !== null ||
    //         selectorRateDateFrom !== null ||
    //         selectorRateDateTo !== null ||
    //         selectorCurrencyFrom !== null ||
    //         selectorCurrencyTo !== null ||
    //         selectorIsActive !== null ||
    //         selectorSource !== null
    //     )
    //     {
    //         {
    //             exchangeSearch(
    //                 selectorIdFrom,
    //                 selectorIdTo,
    //                 selectorExternalIdFrom,
    //                 selectorExternalIdTo,
    //                 selectorRateDateFrom,
    //                 selectorRateDateTo,
    //                 selectorCurrencyFrom,
    //                 selectorCurrencyTo,
    //                 selectorSource,
    //             selectorIsActive
    //             )

    //                 .then(data => {
    //                         console.log(data);
    //                         setExchanges(data);
    //                     }
    //                 )
    //         }
    //     }
    //     else{console.log("search triggered, nothing to search.")}}

    const fetchExchanges = () => {

        const request = {

            idFrom: selectorIdFrom,
            idTo: selectorIdTo,

            externalIdFrom: selectorExternalIdFrom,
            externalIdTo: selectorExternalIdTo,

            rateDateFrom: selectorRateDateFrom,
            rateDateTo: selectorRateDateTo,

            currencyFrom: selectorCurrencyFrom,
            currencyTo: selectorCurrencyTo,

            source: selectorSource,

            isActive: selectorIsActive
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            exchangeSearch(request)


                .then(data => {

                    console.log(data);

                    setExchanges(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }

                })

        .finally(() => {

                // setSubmitting(false);
                dispatchData(changeExternalData({ submitting: false }));
            });
        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************

    const renderExchanges = exchanges => {
        if (exchanges.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }

    // useEffect(() => {
    //     fetchExchanges();
    //     dispatchData(changeExchange({exchangeGridRefresh: false}));
    // }, [useSelector((state) => state.exchangeSlc.value.exchangeGridRefresh)===true]);

    useEffect(() => {

        if (selectorExchangeGridRefresh) {

            fetchExchanges();

            dispatchData(changeExchange({
                exchangeGridRefresh: false
            }));
        }

    }, [selectorExchangeGridRefresh]);

    function handleSearch(){
        setShowSearch(!showSearch)
    }

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeExchange({id: null, externalId: null,
            rateDate: null, currencyFrom: null, currencyTo: null,
            rate: null, source: null, effectiveDate: null, expiredOn: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            exchangeDrawerState: true, exchangeDrawerMode: "Add"}));
    };


    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Exchange"}));
    };

    const removeExchange = () => {
        deleteExchange(selectorExchangeId).then(() => {
            // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorExchangeId} was deleted`);
            setDeleteOpen(false);
            dispatchData(changeExchange({exchangeGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {
        // const [open, setOpen] = useState(false);

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };

        const handleDelete = () => {
            // Place your delete logic here
            deleteExchange(selectedId).then(() => {
                // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorFinancialId} was deleted`);
                setDeleteOpen(false);
                dispatchData(changeExchange({exchangeGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };
    // ****************** END CRUD ***********************************


    const gridClear = () => {

        setExchanges([]);
    }


    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (exchanges) => {

        console.log('Exchange data from clicked row');
        console.log(exchanges);
        dispatchData(changeExchange({id: exchanges.id, externalId: exchanges.externalId,
            rateDate: exchanges.rateDate, currencyFrom: exchanges.currencyFrom,
            currencyTo: exchanges.currencyTo,
            rate: exchanges.rate, source: exchanges.source,
            effectiveDate: exchanges.effectiveDate,
            expiredOn: exchanges.expiredOn,
            createdOn: exchanges.createdOn,createdBy:exchanges.createdBy,
            lastModifiedOn:exchanges.lastModifiedOn,lastModifiedBy:exchanges.lastModifiedBy}));
    };




    const handleExchangeInfo = () => {
        setExchangeInfoOpen(true);
    };

    const handleCloseExchangeInfo = () => {
        setExchangeInfoOpen(false);
    };


    // ****************** BEGIN RETURN ****************************









    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleExchangeInfo()}
                    >Exchange Rates</h3>
                    </Tooltip>
                    <ExchangeInfoDialogue
                        open={exchangeInfoOpen}
                        onClose={handleCloseExchangeInfo}
                    />
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {showSearch && <ExchangeSearch
                gridClear={gridClear}
            />}
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <ExchangeDrawer
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Exchanges"}
                rows={exchanges}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={ExchangeGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeExchange({ exchangeDrawerState: true, exchangeDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeExchange({ exchangeDrawerState: true, exchangeDrawerMode: "Clone" })),
                    onDelete: removeExchange
                })}
                onRowClick = {(exchanges)=>handleClickedRow(exchanges.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={exchange => exchange.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



